export const STREAM_TYPES = {
  MATCH: 'match',
  LIVE_AUCTION: 'live_auction',
  ONLINE_AUCTION: 'online_auction',
};

export const normalizeStreamType = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (Object.values(STREAM_TYPES).includes(normalized)) return normalized;
  return STREAM_TYPES.MATCH;
};

export const normalizeReplay = (replay = {}, fallbackUrl = '') => {
  const url = String(replay?.url || replay?.replayUrl || fallbackUrl || '').trim();
  const status = String(replay?.status || (url ? 'available' : 'pending')).trim().toLowerCase() || 'pending';
  return {
    status,
    url,
    availableAt: replay?.availableAt || null,
    updatedAt: replay?.updatedAt || null,
  };
};

export const normalizeAlert = (alert = {}) => ({
  code: String(alert?.code || 'unknown').trim() || 'unknown',
  severity: ['info', 'warning', 'critical'].includes(alert?.severity) ? alert.severity : 'warning',
  message: String(alert?.message || 'Alert').trim() || 'Alert',
  details: alert?.details && typeof alert.details === 'object' ? alert.details : {},
});

export const normalizeDashboardItem = (item = {}) => ({
  ...item,
  streamType: normalizeStreamType(item.streamType),
  replay: normalizeReplay(item.replay),
  alerts: Array.isArray(item.alerts) ? item.alerts.map(normalizeAlert) : [],
});

export const canTakeover = (item = {}, userCanTakeover = true) => userCanTakeover
  && (item.alerts || []).some((alert) => alert.code === 'heartbeat_expired');
